export default __webpack_public_path__ + "media/zurb/img/lab/playground/playground-hero-bg2-a5bbd1b04ea1038aa31adb791094a574.png";